import React from 'react';
import DetailProvider from '@components/Review/Detail';

export default (props) => <DetailProvider {...props} hasReview />;
